/* eslint-disable @typescript-eslint/promise-function-async */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageGuard } from '@guards/page.guard';
import { RoutePaths } from '@global/routePaths';
import { NewQuotation } from './pages/flow-routes/new-quotation/new-quotation.routing';
import { ModifyQuotation } from './pages/flow-routes/modify-quotation/modify-quotation.routing';
import { ModifyPolicyRoutes } from './pages/flow-routes/modify-policy/modify-policy.routing';
import { EmailRoutes } from '@pages/flow-routes/modify-policy/email/email.routing';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { ModifyRenewalRoutes } from '@pages/flow-routes/modify-renewal/modify-renewal.routing';

const routes: Routes = [
  {
    path: RoutePaths.EMPTY.route,
    redirectTo: RoutePaths.GENERIC_ERROR.route,
    pathMatch: 'full',
  },
  {
    path: RoutePaths.COMPONENTS_PREVIEW.route,
    loadChildren: () =>
      import('@pages/components-preview/components-preview.module').then(m => m.ComponentsPreviewPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MAINTENANCE_PAGE.route,
    loadChildren: () => import('@pages/maintenance/maintenance.module').then(m => m.MaintenancePageModule),
    canActivate: [PageGuard],
  },
  {
    path: RoutePaths.GENERIC_ERROR.route,
    loadChildren: () => import('@pages/generic-error/generic-error.module').then(m => m.GenericErrorPageModule),
    canActivate: [PageGuard],
  },
  ...NewQuotation,
  ...ModifyQuotation,
  ...EmailRoutes,
  ...ModifyPolicyRoutes,
  ...ModifyRenewalRoutes,
  {
    path: RoutePaths.WILDCARD.route,
    redirectTo: RoutePaths.GENERIC_ERROR.route,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
